import { useEffect } from "react";

const FRAMES: readonly [string, ...string[]] = [
  "s3p_ the vibe cloud",
  "s3p_ the free cloud",
  "s3p_ the instant cloud",
  "s3p_ the fast cloud",
  "s3p_ the cheap cloud",
];

const INTERVAL_MS = 2000;

/** Cycles the browser-tab title through the taglines. Marketing host only —
 *  the console host keeps a stable title so its tab stays findable.
 *  Browsers throttle timers in background tabs, so the cycle may slow to
 *  ~1 frame/min there; the visible frame is always a valid tagline. */
export function TitleCycler() {
  useEffect(() => {
    let i = 0;
    const id = setInterval(() => {
      i = (i + 1) % FRAMES.length;
      document.title = FRAMES[i] ?? FRAMES[0];
    }, INTERVAL_MS);
    return () => {
      clearInterval(id);
      document.title = FRAMES[0];
    };
  }, []);

  return null;
}
